export const ScrollBehavior = {
  Auto: 'auto',
  Smooth: 'smooth',
};
